import { useLiveQuery } from "dexie-react-hooks"

import { dexie } from "../../db"
import type { LiveQueryResult } from "../../types"
import type { VideoItem } from "./videos"

export function useAllVideosForSession(sessionId: string): LiveQueryResult<VideoItem[]> {
  return useLiveQuery(
    async () => ({
      data: await dexie.videos.where("sessionId").equals(sessionId).toArray(),
      isLoading: false,
    }),
    [sessionId],
    { data: undefined, isLoading: true },
  )
}

/** Pending videos ready for upload (not failed, not uploaded) */
export function usePendingVideosForUpload(sessionId: string): LiveQueryResult<VideoItem[]> {
  return useLiveQuery(
    async () => ({
      data: await dexie.videos
        .where("sessionId")
        .equals(sessionId)
        .and((v) => v.uploaded === 0 && v.readyToUpload === 1 && !v.uploadFailed)
        .toArray(),
      isLoading: false,
    }),
    [sessionId],
    { data: undefined, isLoading: true },
  )
}
